import { render, staticRenderFns } from "./time.vue?vue&type=template&id=c021b242&scoped=true&"
import script from "./time.vue?vue&type=script&lang=js&"
export * from "./time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c021b242",
  null
  
)

export default component.exports